import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg width="24" height="24" stroke="#000" fill="none" fillRule="evenodd" xmlns="http://www.w3.org/2000/svg" {...props}><rect x=".5" y="8" width="15" height="15" rx="2" /><path d="M8 6V2.5s0-2 2-2h11s2 0 2 2h0v11s0 2-2 2h0-4" strokeLinejoin="round" /></svg>;